import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateSelectorComponent } from './date-selector.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'app/modules/shared/shared.module';



@NgModule({
  declarations: [DateSelectorComponent],
  imports: [
    SharedModule,
    MatIconModule
  ],
  exports: [DateSelectorComponent]
})
export class DateSelectorModule { }
